import {ResponsiveTableColumnsDefinition} from '@aviary/components/table/table.component.types';
import {CombinedCoverTitleDetailComponent} from '@lib/components/combined-cover-title-detail/combined-cover-title-detail.component';
import {ColumnDefinition} from '@store/aviary/aviary.adapter';
import {Checkout} from '@store/checkouts/checkouts.types';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';

type CheckoutSelectors = typeof CheckoutsSelectors.CheckedOut | typeof CheckoutsSelectors.DependentCheckedOut;

export const CHECKOUTS_TABLE_COLUMNS_DEFINITION: ColumnDefinition<Checkout, CheckoutSelectors>[] = [
  {
    type: 'text',
    value: 'dueDateFor',
    header: 'Due Date',
    format: 'DATE_ONLY',
    cssClasses: {
      'text-error': 'overDueFor',
      'text-title-medium': 'overDueFor'
    },
    headerCssClasses: 'w-[7rem]',
    sortable: true,
  },
  {
    type: 'component',
    columnName: 'itemLg',
    header: 'Item',
    componentClass: CombinedCoverTitleDetailComponent,
    componentProperties: {
      catalogRecord: 'buildCatalogRecordFor',
      detail1: 'itemBarcodeFor',
    },
    sortable: true,
    sortKey: 'title'
  },
  {
    type: 'component',
    columnName: 'itemMd',
    header: 'Item',
    componentClass: CombinedCoverTitleDetailComponent,
    componentProperties: {
      catalogRecord: 'buildCatalogRecordFor',
      detail1: 'itemBarcodeFor',
      detail2: 'itemMediaTypeFor',
    },
    sortable: true,
    sortKey: 'title'
  },
  {
    type: 'component',
    columnName: 'itemSm',
    componentClass: CombinedCoverTitleDetailComponent,
    componentProperties: {
      catalogRecord: 'buildCatalogRecordFor',
      showCover: false,
      detail1: 'itemBarcodeFor',
      detail2: 'itemMediaTypeFor',
      date1Label: 'Due Date',
      date1: 'dueDateFor',
      date1Error: 'overDueFor',
      date2Label: 'Check Out Date',
      date2: 'checkoutTimeFor',
    }
  },
  {
    type: 'text',
    value: 'itemMediaTypeFor',
    header: 'Material Type',
    headerCssClasses: 'w-[10rem]',
    truncate: true,
    sortable: true,
    sortKey: 'materialType'
  },
  {
    type: 'text',
    value: 'checkoutTimeFor',
    header: 'Check Out Date',
    format: 'DATE_ONLY',
    headerCssClasses: 'w-[10rem]',
    sortable: true,
  }
];

export const CHECKOUTS_TABLE_RESPONSIVE_DEFINITION:ResponsiveTableColumnsDefinition = {
  verticalActionsSm: true,
  responsiveHideHeaderRow: true,
  columnNamesSm: ['itemSm'],
  columnNamesMd: ['dueDate', 'itemMd', 'checkoutTime'],
  columnNamesLg: ['dueDate', 'itemLg', 'itemMediaType', 'checkoutTime']
};
